import yup from "src/utils/yup/extensionMethods";

const addOrChangeSchema = (translate: Function) => yup.object().shape({
	inb001Titulo: yup.string().required(translate("Título é requerido")).max(200, translate("Título deve conter no máximo 200 caracteres")),
	inb001Dtinicio: yup.date().nullable().required(translate("Data Inicial é requerida")),
	inb001Dtfim: yup.date().nullable().required(translate("Data Final é requerida")).min(
		yup.ref("inb001Dtinicio"),
		translate("Data Final tem que ser após a Data Inicial")
	),
	inb001Efa005Id: yup.string().required(translate("Responsável é requerido")),
	inb001Efa005Id2: yup.string().required(translate("Autoridade é requerido")),
	inb001Tipo: yup.string(),
	inb001Duracao: yup.string().when("inb001Tipo", {
		is: "2",
		then: yup.string().required(translate("Duração é requerido"))
	}),
	inb001Exigeeficacia: yup.string(),
	inb001Efa004Id:  yup.string().when("inb001Exigeeficacia", {
		is: "S",
		then: yup.string().required(translate("Grupo de qualidade é requerido"))
	}),
	inb001Tags: yup.array().of(yup.string()),
	intbb009: yup.array().of(yup.object().shape({
		inb009Id: yup.string(),
		inb009Titulo: yup.string().required(translate("Título é requerido")),
		inb009Peso: yup.number(),
		intbb010: yup.array().of(yup.object().shape({
			inb010Item: yup.string().required(translate("Descrição é requerido")),
			inb010Id: yup.string(),
			inb010Peso: yup.number()
		})).required(translate("É necessario preencher ao menos um item de checklist"))
	})), 
	intbb002: yup.array().of(yup.object().shape({
		inb002Id: yup.string(),
		inb002Notificaparticipante: yup.string(),
		inb002Tipo: yup.string(),
		inb002Efa005Id: yup.string(),
		inb002Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.inb002Efa005Id, (a: any) => !a.inb002Efa004Id && a.inb002Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.inb002Efa005Id, (a: any) => !a.inb002Efa004Id && a.inb002Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.inb002Efa004Id, (a: any) => !a.inb002Efa005Id && a.inb002Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.inb002Efa004Id, (a: any) => !a.inb002Efa005Id && a.inb002Tipo === "I")
});

export const changeProgressSchema = (translate: Function) => yup.object().shape({
	date: yup.date().nullable().required(translate("Data é requerido")),
	description: yup.string().required(translate("Descrição é requerido"))
});

export const errorsPostponementSchema = (translate: Function) => yup.object().shape({
	date: yup.date().nullable().required(translate("Data Inicial é requerida")),
	dateEnd: yup.date().nullable().required(translate("Data Final é requerida")).min(
		yup.ref("date"),
		translate("Data Final tem que ser após a Data Inicial")
	),
	description: yup.string().required(translate("Descrição é requerido"))
});

export const errorsPostponementConfirmSchema = (translate: Function) => yup.object().shape({
	approve: yup.string(),
	reason: yup.string().when("approve", {
		is: "N",
		then: yup.string().required(translate("Motivo é requerido"))
	})
});

export const errorsCancelConfirmSchema = errorsPostponementConfirmSchema;

export const errorsCancelSchema = (translate: Function) => yup.object().shape({
	description: yup.string().required(translate("Descrição é requerido"))
});

export const errorsAddEfficiencytSchema = (translate: Function) => yup.object().shape({
	date: yup.date().nullable().required(translate("Data é requerida")),
	description: yup.string().required(translate("Descrição é requerido"))
});

export default addOrChangeSchema;
